"use client";
import Image from "next/image";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import React, { useCallback, useState } from "react";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import { useTranslations } from "next-intl";
import MenuItem from "@mui/material/MenuItem";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useGetCustomerQuery } from "@/lib/redux";
import useLogoutHook from "@/lib/hooks/logoutHook";
import Languageswitch from "@/i18n/languageswitch";
import { ListItemIcon, Stack, useTheme } from "@mui/material";
import ModalComponent from "./Modal";
import ButtonComponent from "./Button";
import LogoutConfirmationModal from "@/screens/logout/LogoutConfirmationModal";

function NavbarComponent({ product = "" }) {
  const theme = useTheme();
  const t = useTranslations("Login");
  const { handleLogout } = useLogoutHook(product);
  const [openModal, setOpenModal] = useState(false);
  const [openGROModal, setOpenGROModal] = useState(false);
  //get customer details
  const { data: customerData } = useGetCustomerQuery();
  //get application details
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [logoutModal, setLogoutModal] = useState(false);
  const handleOpenUserMenu = useCallback(
    (event) => {
      setAnchorElUser(event.currentTarget);
    },
    [setAnchorElUser],
  );
  const handleCloseUserMenu = useCallback(() => {
    setAnchorElUser(null);
  }, [setAnchorElUser]);

  const onClickLogout = useCallback(() => {
    setLogoutModal(false);
    handleLogout();
  }, []);

  return (
    <>
      <AppBar position="static">
        <Container
          maxWidth={false}
          sx={{
            bgcolor: "#fff",
            color: theme.palette.primary.main,
          }}
        >
          <Toolbar>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <Image
                quality={100}
                priority={100}
                src={IMAGES.navlogo2}
                alt="Hero Fincorp Limited"
                style={{ marginRight: "5px" }}
                width={100}
              />
            </Typography>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <Image
                quality={100}
                priority={100}
                src={IMAGES.navlogo2}
                alt="Hero Fincorp Limited"
                width={100}
              />
            </Typography>
            <Box
              sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}
            ></Box>

            <Box sx={{ flexGrow: 0 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ ml: 1 }}
                alignItems="center"
              >
                <Stack>
                  <Typography
                    sx={{
                      display: { xs: "none", sm: "block" },
                      wordSpacing: 1,
                    }}
                    fontFamily={"inherit"}
                    variant="subtitle2"
                    textTransform={"capitalize"}
                  >
                    {t("welcomeguest")}{" "}
                    <strong>
                      {" "}
                      {customerData?.data?.firstName
                        ? `${customerData?.data?.firstName?.toLowerCase()} ${customerData?.data?.lastName?.toLowerCase()}`
                        : t("guest")}
                    </strong>
                  </Typography>
                </Stack>
                <Tooltip title="Open settings">
                  <Avatar
                    onClick={handleOpenUserMenu}
                    sx={{
                      ml: 2,
                      bgcolor: theme.palette.primary.main,
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  ></Avatar>
                </Tooltip>
                {/* <ListItemIcon id="cardIcon" sx={{ ml: 2 }}>
                  <Notifications />
                </ListItemIcon> */}
              </Stack>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  onClick={() => {
                    setOpenGROModal(true);
                    handleCloseUserMenu();
                  }}
                >
                  <ListItemIcon>
                    <Image src={IMAGES.infoGreen} alt="Data Retention" />
                  </ListItemIcon>
                  <Typography textAlign="center">
                    Grievance Redressal Officer
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    window.open(
                      process.env.NEXT_PUBLIC_HIPL_DLG_PORTAL_URL,
                      "_blank",
                    );
                    handleCloseUserMenu();
                  }}
                >
                  <ListItemIcon>
                    <Image src={IMAGES.infoGreen} alt="Data Retention" />
                  </ListItemIcon>
                  <Typography textAlign="center">HIPL DLG Portal</Typography>
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    setOpenModal(true);
                    handleCloseUserMenu();
                  }}
                >
                  <ListItemIcon>
                    <Image src={IMAGES.infoGreen} alt="Data Retention" />
                  </ListItemIcon>
                  <Typography textAlign="center">Data Retention</Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setLogoutModal(true);
                    handleCloseUserMenu();
                  }}
                >
                  <ListItemIcon>
                    <Image src={IMAGES.logout} alt="logout" />
                  </ListItemIcon>
                  <Typography textAlign="center">Logout</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
        <ModalComponent open={openModal} handleModal={setOpenModal}>
          <Stack spacing={2} p={2} alignItems="center" justifyContent="center">
            <Image
              src={IMAGES.infoGreen}
              alt="Data Retention"
              height={70}
              width={70}
            />
            <Typography>
              <strong>Note: </strong>
              In line with recent RBI guidelines, customer data will be retained
              for a period of 10 years, as outlined in our Policy on
              Preservation and Archival of Documents. After this period, all
              data is securely deleted in accordance with our internal data
              purging protocols.
            </Typography>
            <ButtonComponent
              onClick={() =>
                window.open(
                  process.env.NEXT_PUBLIC_DATA_RETENTION_URL,
                  "_blank",
                )
              }
            >
              View Preservation & Documents Archival Policy{" "}
            </ButtonComponent>
          </Stack>
        </ModalComponent>
        <ModalComponent
          title={""}
          open={openGROModal}
          handleModal={setOpenGROModal}
        >
          <Stack spacing={2} p={2} alignItems="center" justifyContent="center">
            <Image
              src={IMAGES.infoGreen}
              alt="Data Retention"
              height={70}
              width={70}
            />
            <Stack spacing={1}>
              <Typography variant="h6" fontWeight={700} mb={1} fontSize={22}>
                Grievance Redressal Officer
              </Typography>
              <Typography
                fontWeight={700}
                color={WEB_COLORS.darkTeal}
                fontSize={18}
              >
                Hero Fincorp Limited
              </Typography>
              <Stack px={1} spacing={1}>
                <Typography
                  fontWeight={700}
                  color={WEB_COLORS.darkTeal}
                  fontSize={18}
                >
                  Mr. Monish Vohra
                </Typography>
                <Typography fontSize={12}>
                  Hero Fincorp Ltd. A-44, Mohan Co-Operative Industrial Estate,
                  Mathura Road, New Delhi - 110044
                </Typography>
                <Typography fontSize={14}>
                  <strong>Email: </strong>
                  <a href="mailto:nodal.officer@herofincorp.com">
                    nodal.officer@herofincorp.com
                  </a>
                </Typography>
                <Typography fontSize={14}>
                  <strong>Contact Number: </strong>
                  <a href="tel:01243633945">0124-3633945</a> (Monday to Friday,
                  and on the last two Saturdays of the month, 10:00 am to 6:00
                  pm)
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </ModalComponent>
      </AppBar>
      <Languageswitch />
      <LogoutConfirmationModal
        onSubmit={onClickLogout}
        onReject={() => setLogoutModal(false)}
        open={logoutModal}
      />
    </>
  );
}
export default NavbarComponent;
